export default "__VITE_ASSET__C6uD2IZ4__"